/**
 * DELIVERY POINTS
 */
export const API_DELIVERY_POINTS = "/api/delivery_points";

/**
 * COMPANY GROUPS
 */
export const API_COMPANY_GROUPS = "/api/company_groups";

/**
 * COMPANIES
 */
export const API_COMPANIES = "/api/companies";
export const API_COMPANIES_WITHOUT_DEFAULT_DIRECTIVES = "/api/companies/quantity_of_companies_without_default_directives";

/**
 * PRODUCT SIZES
 */
export const API_PRODUCT_SIZES = "/api/product_sizes";

/**
 * PRODUCT SPECIES
 */
export const API_PRODUCT_SPECIES = "/api/product_species";

/**
 * PRODUCT FRESHNESS
 */
export const API_PRODUCT_FRESHES = "/api/product_freshes";

/**
 * CONTAINERS
 */
export const API_CONTAINERS = "/api/containers";

/**
 * COMPANY CONTACTS
 */
export const API_COMPANY_CONTACTS = "/api/company_contacts";

/**
 * DEFAULT LOT MANAGEMENT DIRECTIVES
 */
export const API_DEFAULT_LOT_MANAGEMENT_DIRECTIVES = "/api/lot_management_directives/defaults";

/**
 * LOT MANAGEMENT DIRECTIVES
 */
export const API_LOT_MANAGEMENT_DIRECTIVES = "/api/lot_management_directives";

/**
 * USERS
 */
export const API_USERS = '/api/users';
export const API_USERS_RESET_PASSWORD = (userId) => `${API_USERS}/${userId}/resetPassword`;

/**
 * LOTS
 */
export const API_LOTS = "/api/lots";
export const API_MASS_UPDATE_LOTS = "/api/mass_update/lots/status_and_delivery_point";
export const API_MASS_UPDATE_LOTS_TO_DELIVER_AT = "/api/mass_update/lots/to_deliver_at";

/**
 * STATUS
 */
export const API_STATUS = "/api/status";

/**
 * FISHING MODES
 */
export const API_FISHING_MODES = "/api/fishing_modes";

/**
 * SALE TYPES
 */
export const API_SALE_TYPES = '/api/sale_types'

/**
 * DELIVERY POINT DIRECTIVES
 */
export const API_DELIVERY_POINT_DIRECTIVES = '/api/delivery_point_directives'

/**
 * DELIVERY POINT DIRECTIVE TEMPLATES
 */
export const API_TRANSPORT_TEMPLATES = '/api/transport_models'

/**
 * HISTORIES
 */
export const API_HISTORIES = "/api/histories";

/**
 * LOGISTICAL LOTS
 */
export const API_LOGISTICAL_LOTS = '/api/logistical_lots'

/**
 * PARAMETERS
 */
export const API_PARAMETERS = '/api/parameters'
